import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { ITradeItem } from '~/types/tradein';

interface ITradeInWeWidget {
    item: ITradeItem;
    hideNationIcon?: boolean;
    showRarityIcon?: boolean;
}

const TradeInWeWidget = ({ item, hideNationIcon, showRarityIcon = false }: ITradeInWeWidget) => {
    let isNeedToHideNationIcon = true;
    if (hideNationIcon !== null && hideNationIcon !== undefined) {
        isNeedToHideNationIcon = hideNationIcon;
    }

    return (
        <WoWSEntity
            type={item.type}
            id={item.identifier}
            presentation={{
                renderWithoutFade: true,
                hideNationIcon: isNeedToHideNationIcon,
                hideRarityIcon: !showRarityIcon,
                withTooltip: true,
            }}
        />
    );
};

export default TradeInWeWidget;
